export class DateHelper {
    static fixDate(dateValue: Date | string): Date {
        let date: Date = typeof dateValue === 'string'
            ? new Date(dateValue)
            : dateValue;

        //Setting time to 00 00 00 hours UTC, so no time conversion is done and the date will always be exactly a specific day at midnight
        let tempDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(tempDate.getTime() - tempDate.getTimezoneOffset() * 60000)
    }

    static removeTime(dateValue: Date): Date {
        dateValue.setHours(0,0,0,0);
        return dateValue;
    }
}